"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashed = exports.getHashValues = exports.authorize = void 0;
var hashed = function hashed(o) {
  return Object.getOwnPropertyNames(o).map(function (prop) {
    return "".concat(prop, "=").concat(encodeURIComponent(o[prop]));
  }).join('&');
};
exports.hashed = hashed;
var authorize = function authorize(provider, clientId) {
  var query = {
    client_id: clientId,
    response_type: 'token',
    redirect_uri: window.location
  };
  var url = "".concat(provider, "/authorize?").concat(hashed(query));
  window.location.replace(url);
};
exports.authorize = authorize;
var getHashValues = function getHashValues() {
  var hash = window.location.hash;
  if (hash.match(/^#/)) {
    return hash.substring(1).split('&').reduce(function (o, kv) {
      var a = kv.split('=');
      o[a[0]] = a[1];
      return o;
    }, {});
  } else {
    return {};
  }
};
exports.getHashValues = getHashValues;
//# sourceMappingURL=utils.js.map